// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2Xa9k","title":"ClientInsurance_title__2y5ES","itemText":"ClientInsurance_itemText__2YyYp"};